import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ImportRequest } from '../../shared/models';

@Component({
  selector: 'sp-admin-import-request-list',
  templateUrl: './admin-import-request-list.component.html',
  styleUrls: ['./admin-import-request-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdminImportRequestListComponent implements OnInit {

  @Input() importRequests: ImportRequest[];
  formGroup: UntypedFormGroup = new UntypedFormGroup({});

  constructor(private fb: UntypedFormBuilder) {
  }

  ngOnInit() {
    this.initForm();
  }

  clearFilter() {
    this.formGroup.get('filter').setValue('');
  }

  private initForm() {
    this.formGroup.addControl('filter', this.fb.control(''));
    this.formGroup.addControl('isMostRecentOnly', this.fb.control(true));
  }
}
